import { createClient, Photo } from "pexels";

import { getConfig } from "../config/env.config";

const { pexelsApiKey } = getConfig();

if (!pexelsApiKey) {
  throw new Error("Pexels API key is not configured. Please check your environment variables.");
}

const client = createClient(pexelsApiKey);

export interface SearchOptions {
  /** Number of results to return per page (max 80). Default: 15 */
  perPage?: number;
  /** Page number to fetch. Default: 1 */
  page?: number;
}

/**
 * Search images on Pexels by keyword.
 *
 * @param query   The search term (e.g. "mountains")
 * @param opts    Optional pagination settings
 * @returns       An array of Photo objects from Pexels
 * @throws        If the Pexels API call fails
 */
export async function searchImages(query: string, opts: SearchOptions = {}): Promise<Photo[]> {
  const { perPage = 15, page = 1 } = opts;

  try {
    const response = await client.photos.search({
      query,
      per_page: perPage,
      page,
      orientation: "portrait",
      size: "large",
    });

    if ("photos" in response) {
      return response.photos;
    }
    throw new Error("Invalid response from Pexels API");
  } catch (error) {
    console.error("[Pexels] searchImages error:", error);
    // Wrap and re-throw, or return an empty array depending on your needs
    throw new Error(`Failed to search images: ${(error as Error).message}`);
  }
}
